import React from 'react';
import { ImmocomProvider } from './contexts/ImmocomContext';
import { NotificationContextProvider } from './contexts/notificationContext';
import { PerimetreProvider } from './contexts/PerimetreContext';

// Tuto : https://javascript.plainenglish.io/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e

const combine = (...providers) => {
    return providers.reduce(
        (AccumulatedComponents, CurrentComponent) => {
            return ({ children }) => {
                return (
                    <AccumulatedComponents>
                        <CurrentComponent>{children}</CurrentComponent>
                    </AccumulatedComponents>
                );
            };
        },
        ({ children }) => <>{children}</>,
    );
};

const providers = [
    NotificationContextProvider,
    ImmocomProvider, // Migration en cours vers NotificationContextProvider
    PerimetreProvider, // A mettre � jour
];

export const AppContextProvider = combine(...providers);